import { useContext } from 'react';
import { AnalyticsContext } from 'analytics';

export const useSendEvent = () => {
  const analytics = useContext(AnalyticsContext);
  return analytics.sendEvent;
};
